// extracted by mini-css-extract-plugin
export default {"illustration":"illustration--2fa58d9b"};